import React, { useEffect } from "react";
import "../styles/CustomCursor.css";

function CustomCursor() {
  useEffect(() => {
    const cursor = document.querySelector(".custom-cursor");
    const trail = document.querySelector(".cursor-trail");

    let mouseX = 0;
    let mouseY = 0;

    let trailX = 0;
    let trailY = 0;

    const moveCursor = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      cursor.style.left = `${mouseX}px`;
      cursor.style.top = `${mouseY}px`;
    };

    const animateTrail = () => {
      trailX += (mouseX - trailX) * 0.12;
      trailY += (mouseY - trailY) * 0.12;

      trail.style.left = `${trailX}px`;
      trail.style.top = `${trailY}px`;

      requestAnimationFrame(animateTrail);
    };

    window.addEventListener("mousemove", moveCursor);

    animateTrail();

    return () => {
      window.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  return (
    <>
      <div className="custom-cursor" />
      <div className="cursor-trail" />
    </>
  );
}

export default CustomCursor;